import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useToast } from "hooks/useToast";
import { useDeleteClassificationMutation } from "store/apis/classifications";
import { BackendError } from "types/utils/error";
import { ClassificationWarningModal } from "./ClassificationWarningModal";

type DeleteClassificationModalProps = {
  isOpen: boolean;
  onClose: () => void;
  classificationName: string;
  classificationId: string;
};

export const DeleteClassificationModal = ({
  isOpen,
  onClose,
  classificationName,
  classificationId,
}: DeleteClassificationModalProps) => {
  const entityId = useCurrentEntityId();
  const { alertToast, successToast } = useToast();
  const [deleteClassification, { isLoading }] =
    useDeleteClassificationMutation();

  const handleConfirm = async () => {
    try {
      await deleteClassification({
        entityId,
        payload: {
          class_id: classificationId,
        },
      }).unwrap();

      successToast({
        message: `Classification "${classificationName}" deleted`,
      });
      onClose();
    } catch (error) {
      alertToast(
        { message: (error as BackendError).data?.error?.message },
        error as Error
      );
    }
  };

  return (
    <ClassificationWarningModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={`Delete ${classificationName}`}
      description="Deleting this classification will permanently unassign it from all related transactions. Please confirm to continue."
      isLoading={isLoading}
    />
  );
};
